
    import './styles.scoped.css';
    export default {
  "header-cell-text": "awsui_header-cell-text_dpuyq_1id1o_5"
};
  